// src/client/renderer/shaders/wind-sway.ts
import * as THREE from 'three';
import type { ShaderFactory } from './types';
import { VERTEX as WIND_VERTEX, FRAGMENT as WIND_FRAGMENT } from './wind-sway.glsl';

export interface WindSwayUniforms {
  /** Per-frame time in seconds. Consumer updates. Default: 0. */
  uTime: THREE.IUniform<number>;
  /** Sway intensity (max horizontal displacement, world units). Default: 0.1. */
  uIntensity: THREE.IUniform<number>;
  /** Sway speed (radians/second). Default: 1.5. */
  uSpeed: THREE.IUniform<number>;
  /** Stiffness (vertex Y exponent). Lower = whippy, higher = stiff. Default: 1.5. */
  uStiffness: THREE.IUniform<number>;
  /** Base color. Default: (1,1,1). */
  uBaseColor: THREE.IUniform<THREE.Color>;
}

export const createWindSwayShader: ShaderFactory = () => {
  const uniforms: WindSwayUniforms = {
    uTime: { value: 0 },
    uIntensity: { value: 0.1 },
    uSpeed: { value: 1.5 },
    uStiffness: { value: 1.5 },
    uBaseColor: { value: new THREE.Color(1, 1, 1) },
  };
  return new THREE.ShaderMaterial({
    uniforms: uniforms as unknown as Record<string, THREE.IUniform<unknown>>,
    vertexShader: WIND_VERTEX,
    fragmentShader: WIND_FRAGMENT,
    side: THREE.DoubleSide,
  });
};
